<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<!-- <a-button class="qinang-button-margin" type="primary" icon="plus" @click="tableAdd">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit" :disabled="!tableSelectedRows.length || tableSelectedRows.length !== 1">修改</a-button>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button> -->
				<a-button icon="sync" @click="apiPromotionTeamQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="推广团队查询">
				<div class="qinang-search-row">
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">团队名称：</div>
						<a-input v-model="query.teamTitle" placeholder="请输入团队名称" />
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">姓名：</div>
						<a-input v-model="query.name" placeholder="请输入姓名" />
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">联系电话：</div>
						<a-input v-model="query.phone" placeholder="请输入联系电话" />
					</div>
				</div>
                <div class="qinang-search-row" style="margin-top: 10px;">
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title">申请状态：</div>
                        <a-select v-model="query.teamState" placeholder="请选择申请状态" allowClear>
                            <a-select-option v-for="item in teamStateMap" :key="item.value" :value="item.value">{{item.label}}</a-select-option>
                        </a-select>
                    </div>
                    <div style="display: flex; justify-content: flex-end;">
                        <a-button type="primary" icon="search" @click="apiPromotionTeamQueryList">查询</a-button>
                    </div>
                </div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<div style="display: flex;justify-content: space-between;align-items: center;">
				<a-breadcrumb separator=">" style="padding: 12.5px 16px;" >
					<a-breadcrumb-item>
						推广团队列表
					</a-breadcrumb-item>
				</a-breadcrumb>
			</div>
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="promotionTeamId" :loading="tableLoading" :pagination="false">
				<span slot="teamTitle" slot-scope="text, record">
					<a-button type="link" @click="edit(record)" >{{record.teamTitle}}</a-button>
				</span>
				<span slot="teamState" slot-scope="text, record">
					{{teamStateMap.find(item => item.value === record.teamState)?.label || record.teamState}}
				</span>
				<span slot="createTime" slot-scope="text, record">
					{{moment(record.createTime).format('YYYY-MM-DD HH:mm:ss')}}
				</span>
				<span slot="businessLicense" slot-scope="text, record">
					<img :src="baseUrl+record.businessLicense" alt="营业执照" style="width: 50px;height: 50px;margin-right: 5px;" @click="preview(record.businessLicense)"/>
				</span>
				<span slot="operation" slot-scope="text, record">
					<a-button type="primary" @click="edit(record)" size="small">操作</a-button>
				</span>
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>

		<!-- 修改弹窗 -->
		<a-modal class="qa-modal-half" title="修改" width="800px" :visible="editVisible" :confirm-loading="editConfirmLoading" @ok="editHandleOk" @cancel="handleCancel" :maskClosable="false" :keyboard="false" >
			<a-form-model ref="editRuleForm" :model="editForm" :label-col="{span: 5}" :wrapper-col="{span: 17}" >
				<a-divider orientation="left">
				基础信息
				</a-divider>
				<a-form-model-item label="团队名称" has-feedback >
					<a-input class="qa-input-disabled" v-model="editForm.teamTitle" placeholder="" disabled />
				</a-form-model-item>
				<a-form-model-item label="姓名" has-feedback >
					<a-input class="qa-input-disabled" v-model="editForm.name" placeholder="" disabled />
				</a-form-model-item>
				<a-form-model-item label="身份证号" has-feedback >
					<a-input class="qa-input-disabled" v-model="editForm.card" placeholder="" disabled />
				</a-form-model-item>
				<a-form-model-item label="联系电话" has-feedback >
					<a-input class="qa-input-disabled" v-model="editForm.phone" placeholder="" disabled />
				</a-form-model-item>
				<a-form-model-item label="营业执照" has-feedback >
					<img :src="baseUrl+editForm.businessLicense" alt="营业执照" style="width: 50px;height: 50px;margin-right: 5px;" @click="preview(editForm.businessLicense)"/>
				</a-form-model-item>
				<a-form-model-item label="申请状态" has-feedback prop="teamState">
					<a-select v-model="editForm.teamState" placeholder="请选择申请状态">
						<a-select-option v-for="(item, index) in teamStateMap" :key="index" :value="item.value">{{ item.label }}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-divider orientation="left">
				推广参数
				</a-divider>
				<a-form-model-item label="佣金渠道">
					<a-radio-group name="sourceFunds" v-model="promotionParam.sourceFunds">
						<a-radio :value="1">团队账户</a-radio>
						<a-radio :value="2">个人账户</a-radio>
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="推广比例">
					<a-input-number v-model="promotionParam.promotionRate" placeholder="请输入推广比例" :min="0" :max="1" />
					<a-tag style="margin-left: 10px;" color="orange">
						例: 0.01 等于 1%
					</a-tag>
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		<!-- 预览弹窗 -->
		<a-modal class="qa-modal-half" title="预览" width="800px" :visible="previewVisible" :confirm-loading="false" @cancel="handleImageCancel" :footer="null" :maskClosable="false" :keyboard="false" >
			<img :src="previewImage" alt="预览" style="width: 100%;height: 100%;" />
		</a-modal>
		
	</div>
</template>

<script>
	import moment from 'moment'
	import promotionParamConfig from '@/assets/js/promotionParam'
	export default {
		data() {
			return {
				moment,
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				baseUrl: this.navigation && this.navigation.url ? this.navigation.url : '',
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					teamTitle: undefined,
					name: undefined,
					phone: undefined,
					teamState: undefined,
				},
				tableData: [],
				tableColumns: [
					{ title:'团队ID', dataIndex:'promotionTeamId', key:'promotionTeamId', align:'center'},
					{ title:'团队名称', dataIndex:'teamTitle', key:'teamTitle', align:'center',scopedSlots:{customRender:'teamTitle'}},
					{ title:'姓名', dataIndex:'name', key:'name', align:'center'},
					{ title:'身份证号', dataIndex:'card', key:'card', align:'center'},
					{ title:'联系电话', dataIndex:'phone', key:'phone', align:'center'},
					{ title:'营业执照', dataIndex:'businessLicense', key:'businessLicense', align:'center',scopedSlots:{customRender:'businessLicense'}},
					{ title:'申请状态', key:'teamState', align:'center', scopedSlots:{customRender:'teamState'}},
					{ title:'操作', key:'operation', align:'center', scopedSlots:{customRender:'operation'}}
				],
				tableLoading: false,
				tableSelectedRows: [],
				// 状态映射
				teamStateMap: [
					{
						label: '禁用',
						value: -1
					},
                    {
                        label: '驳回',
                        value: 1
                    },
                    {
                        label: '未审核',
                        value: 2
                    },
                    {
                        label: '已审核',
                        value: 3
                    },
                ],
				//搜索+表格-end

				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
					promotionTeamId: '',
					touristId: undefined,
					enterpriseId: undefined,
					teamTitle: '',
					name: '',
					card: '',
					phone: '',
					businessLicense: '',
					teamState: 2, // 默认未审核
					promotionParam: '',
					totalPrice: 0,
					surplusPrice: 0,
				},
				// 修改弹窗-end
				previewVisible: false,
				previewImage: '',
				promotionParam: {
					...promotionParamConfig.team
				},
			};
		},
		methods: {
			//--------------表格开始-搜索
			async apiPromotionTeamQueryList() {
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPromotionTeamQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiPromotionTeamQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiPromotionTeamQueryList()
			},
			handleCancel() {
				this.editVisible = false
			},

			// 修改
			async edit(item){
				this.editConfirmLoading = false
				let items = JSON.parse(JSON.stringify(item))
				// 解析推广参数
				try {
					this.promotionParam = promotionParamConfig.parseTeamPromotionParam(items.promotionParam)
				} catch (error) {
					this.$message.error('推广参数格式错误')
					return
				}
				// 先打开弹窗
				this.editVisible = true
				// 使用 $nextTick 确保 DOM 渲染完成后再设置表单数据
				await this.$nextTick()
				this.editForm = items
			},
			async apiPromotionTeamEdit() {
				this.editConfirmLoading = true
				// 格式化推广参数
				this.editForm.promotionParam = JSON.stringify(this.promotionParam)
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPromotionTeamEdit, this.editForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.editConfirmLoading = false
					this.editVisible = false
					// 等待弹窗关闭后再刷新列表
					this.apiPromotionTeamQueryList()
				} else {
					this.$message.error(res.msg)
					this.editConfirmLoading = false
				}
			},
			editHandleOk() {
				this.$refs.editRuleForm.validate(valid => {
					if (valid) {
						this.apiPromotionTeamEdit()
					} else {
						return false;
					}
				});
			},
			editHandleCancel() {
				this.editVisible = false
			},
			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.length > 0) {
					const ids = this.tableSelectedRows.map(row=>row.promotionTeamId)
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: '当前选中' + ids.length + '条数据。',
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiPromotionTeamDel(ids)
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiPromotionTeamDel(ids) {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPromotionTeamDel + '/'+ ids);
				if (res.code == 200) {
					this.$message.success(res.msg)
					await this.apiPromotionTeamQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},
			tableEdit() {
				if(this.tableSelectedRows.length === 1) {
					const item = this.tableData.find(item => item.promotionTeamId == this.tableSelectedRows[0].promotionTeamId)
					this.edit(item)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			},
			preview(url) {
				this.previewVisible = true
				this.previewImage = this.baseUrl + url
			},
			handleImageCancel() {
				this.previewVisible = false
			},
			
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					onChange: (selectedRowKeys, selectedRows) => {
						that.tableSelectedRows = selectedRows;
					},
				};
			},
		},
		created() {
			this.apiPromotionTeamQueryList()
		}
	};
</script>

<style scoped>
.qa-input-disabled {
	background-color: #fff !important;
	color: #909399 !important;
	cursor: not-allowed;
}
</style>